import * as React from 'react';
import { SearchFacet } from '#server/models';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  ToggleGroup,
  ToggleGroupItem,
  SortBy,
} from '@/components';
import { useFilterStore } from '@/store';
import { useDeviceType } from '@/hooks';

interface ResultsHeaderProps {
  currentPage: number;
  itemsPerPage: number;
  totalResults: number;
  facet: SearchFacet;
  showRegion?: boolean;
  ref?: React.Ref<HTMLDivElement>;
}

export function ResultsHeader({ currentPage, itemsPerPage, totalResults, facet, showRegion, ref }: ResultsHeaderProps) {
  const { isDesktop } = useDeviceType();
  const { region, actions: filterActions } = useFilterStore();
  const setRegion = (v: string) => {
    filterActions.setRegion(v as 'domestic' | 'international');
    filterActions.clearFilter('Start date');
  };

  return (
    <div ref={ref} className="flex flex-col space-y-6">
      {!isDesktop && showRegion && (
        <ToggleGroup
          className="mt-4 self-center"
          value={region}
          type="single"
          onValueChange={(value) => {
            if (value) setRegion(value);
          }}
        >
          <ToggleGroupItem value="domestic">Domestic</ToggleGroupItem>
          <ToggleGroupItem value="international">International</ToggleGroupItem>
        </ToggleGroup>
      )}
      <div className="flex items-end justify-between xl:items-center">
        <div>
          {totalResults > 0 ? (
            <>
              <span className="font-bold">
                {(currentPage - 1) * itemsPerPage + 1} - {Math.min(currentPage * itemsPerPage, totalResults)}
              </span>{' '}
              of{' '}
            </>
          ) : (
            ''
          )}
          <span className="font-bold">{totalResults}</span> results in{' '}
          <span className="font-bold">{facet === 'all' ? 'all results' : facet}</span>
        </div>
        {isDesktop && (
          <div className="flex flex-col gap-2 xl:flex-row xl:gap-6">
            {showRegion && (
              <div className="flex items-center gap-2">
                Select region:
                <Select onValueChange={setRegion} value={region}>
                  <SelectTrigger>
                    <SelectValue placeholder="Domestic" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="domestic">Domestic</SelectItem>
                    <SelectItem value="international">International</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            )}
            <div className="flex items-center justify-end gap-2">
              Sort by:
              <SortBy />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
